<div class="tt-anchor-link_header">
  <span>{{ 'Links' | transloco }}:</span>
  @if (!currentLink()) {
    <button
      aria-label="Add link button"
      data-testid="anchor-link_add-chapter-link-button"
      emphasis="minimal"
      size="icon"
      ttButton
      variant="primary"
      (click)="handleAddLinkButtonClicked()">
      <mat-icon [icon]="'circle-plus-filled'" [iconSize]="18" />
    </button>
  }
</div>

@if (currentLink() && !currentLink().id) {
  <tt-anchor-link-edit [link]="currentLink()" (cancelEdit)="cancelEdit()" (saveLink)="saveLink($event)" />
}

@if (links()?.length > 0) {
  @for (link of links(); track link.id) {
    @if (link.id === currentLink()?.id) {
      <tt-anchor-link-edit [link]="currentLink()" (cancelEdit)="cancelEdit()" (saveLink)="saveLink($event)" />
    } @else {
      <tt-anchor-link-item [link]="link" (editLinkClicked)="currentLink.set(link)" (removeLinkClicked)="removeLink($event.id)" />
    }
  }
}
